import React from "react";
import TBGallery from "../../../photoGallery/TBGallery";
import Image2 from "../../../../assets/gallery/latestProjects/NathanCohen/2.webp";
import Image3 from "../../../../assets/gallery/latestProjects/NathanCohen/3.webp";
import Image4 from "../../../../assets/gallery/latestProjects/NathanCohen/4.webp";
import Image5 from "../../../../assets/gallery/latestProjects/NathanCohen/5.webp";
import Image6 from "../../../../assets/gallery/latestProjects/NathanCohen/6.webp";
import Image7 from "../../../../assets/gallery/latestProjects/NathanCohen/7.webp";
import Image8 from "../../../../assets/gallery/latestProjects/NathanCohen/8.webp";
import Image9 from "../../../../assets/gallery/latestProjects/NathanCohen/9.webp";
import Image10 from "../../../../assets/gallery/latestProjects/NathanCohen/10.webp";
import { ProjectDetails } from "./ProjectDetails";
import "../../projectStyling/style.css"
import Footer from "../../../Footer";

const NathanCohen = () => {
  const galleryImages = [
    {
      img: Image2,
    },
    {
      img: Image3,
    },
    {
      img: Image4,
    },
    {
      img: Image5,
    },
    {
      img: Image6,
    },
    {
      img: Image7,
    },
    {
      img: Image8,
    },
    {
      img: Image9,
    },
    {
      img: Image10,
    },
  ];
  return (
    <>
      <br />
      <div>
        <ProjectDetails />
      </div>
      <br />
      <div>
        <TBGallery galleryImages={galleryImages} />
      </div>
      <div><Footer /></div>
    </>
  );
};

export default NathanCohen;
